import { getCurrentActiveSidebarNav } from "./getCurrentActiveSidebarNav";

import { TTabItem } from "components/Layout/Navbar/Tab/types";
import { buSlugParam } from "routes/constants";

type GenerateTabItemsParams = {
  tabList: Record<string, Record<string, string>>;
  tabLabel: Record<string, string>;
  buSlug?: string;
  pathname: string;
};

export const generateTabItems = ({
  tabLabel,
  tabList,
  buSlug,
  pathname,
}: GenerateTabItemsParams): TTabItem => {
  let tabItem: TTabItem = {};
  const domain = getCurrentActiveSidebarNav(pathname);
  let replacers: Array<{ key: string; slug?: string }> = [];

  if (buSlug) {
    replacers = [{ key: `:${buSlugParam}`, slug: buSlug }];
  }

  for (const key in tabList) {
    if (tabList?.[key]?.[domain] !== undefined) {
      let path = tabList?.[key]?.[domain];

      for (const replacer of replacers) {
        path = path.replace(replacer.key || "", replacer.slug || "");
      }

      if (path) {
        tabItem = {
          ...tabItem,
          [key]: {
            label: tabLabel?.[key] || "",
            path: path,
          },
        };
      }
    }
  }

  return tabItem;
};
